export default __webpack_public_path__ + "static/media/logo.f03f8d4d.svg";